import React from 'react';
import styles from './CtaSection.module.css';
import { trackCtaClick } from '../../../../utils/analytics';

const benefits = [
  {
    label: '30 dias grátis',
    // Ícone: calendário com estrela — representa período de teste gratuito
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="17" rx="2" stroke="white" strokeWidth="1.8"/>
        <path d="M3 9h18" stroke="white" strokeWidth="1.8"/>
        <path d="M8 2v4M16 2v4" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M12 13l.5 1.5H14l-1.2.9.5 1.6L12 16l-1.3 1 .5-1.6L10 14.5h1.5L12 13z" fill="white"/>
      </svg>
    ),
  },
  {
    label: 'Sem fidelidade',
    // Ícone: cadeado aberto — representa liberdade, sem contrato
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5" y="11" width="14" height="10" rx="2" stroke="white" strokeWidth="1.8"/>
        <path d="M8 11V7a4 4 0 0 1 8 0" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
        <circle cx="12" cy="16" r="1.5" fill="white"/>
      </svg>
    ),
  },
  {
    label: 'Cancele quando quiser',
    // Ícone: X dentro de círculo — representa cancelamento
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="1.8"/>
        <path d="M9 9l6 6M15 9l-6 6" stroke="white" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
  },
];

function CtaSection({ onOpenModal }) {
  return (
    <section id="form-acesso" className={styles.ctaSection}>
      <div className={styles.sectionContainer}>
        <h2 className={styles.title}>
          Sua rotina mais organizada<br/>começa aqui
        </h2>
        <p className={styles.subtitle}>
          Teste gratuitamente todas as funcionalidades<br/>da Gabriela por 30 dias.
        </p>

        <div className={styles.benefits}>
          {benefits.map((b, i) => (
            <div key={i} className={styles.benefitItem}>
              <div className={styles.benefitIcon}>{b.icon}</div>
              <span className={styles.benefitLabel}>{b.label}</span>
            </div>
          ))}
        </div>

        <button
          className={styles.ctaButton}
          onClick={() => {
            trackCtaClick({ placement: 'final_cta_section' });
            onOpenModal();
          }}
        >
          Criar minha conta grátis
        </button>

        <div className={styles.noCardBadge}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2" y="5" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="1.8"/>
            <path d="M2 10h20" stroke="currentColor" strokeWidth="1.8"/>
            <path d="M6 15h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
          </svg>
          Não precisa de cartão de crédito
        </div>
      </div>
    </section>
  );
}

export default CtaSection;
